export const memberIndex = {
  buyHistoryClick: '10665.0', // 付费会员权益-购买记录点击
  ruleClick: '10666.0', // 付费会员权益-会员规则点击
  typeClick: '10667.0', // 付费会员权益-会员类型点击
  couponUse: '10668.0', // 付费会员权益-会员券包-去使用点击
  AgreementClick: '10669.0', // 付费会员权益-会员协议点击
  openClick: '1410.0', // 付费会员权益-立即开通点击
  cancleClick: '10661.0', // 付费会员-购买同意协议- 不同意点击
  agreeClick: '10662.0' // 付费会员-购买同意协议- 同意并支付点击
}
